import { forwardRef, PropsWithChildren, Ref } from 'react';
import classNames from 'classnames';
import {
  IconButton,
  IconButtonProps,
  Tooltip,
} from '@mui/material';
import { Color } from 'shared/utils/colors';

import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles({
  iconButton: {
    '&:hover': {
      backgroundColor: Color.primaryOrangeHover,
    },
    '&:active': {
      backgroundColor: Color.primaryOrangeActive,
    },
  },
});

const ButtonIcon = (
  {
    children,
    title,
    ...props
  }: PropsWithChildren<IconButtonProps & { title?: string }>,
  ref: Ref<any> | undefined
): JSX.Element => {
  const classes = useStyles();
  if (title && !props.disabled) {
    return (
      <Tooltip title={title}>
        <IconButton
          {...props}
          ref={ref}
          disableRipple={props?.disableRipple}
          className={classNames(classes.iconButton, props.className)}
          size='large'
        >
          {children}
        </IconButton>
      </Tooltip>
    );
  }

  return (
    <IconButton
      {...props}
      ref={ref}
      disableRipple={props?.disableRipple}
      className={classNames(classes.iconButton, props.className)}
      size='large'
    >
      {children}
    </IconButton>
  );
};

export default forwardRef(ButtonIcon);
